import styled from "styled-components";
import forumIcon from "./img/forum.png"
import editIcon from "./img/edit.png"
import nearMeIcon from "./img/near_me.png"
import personPinIcon from "./img/person_pin.png"
import importContacsIcon from "./img/import_contacts.png"
import fileDownloadIcon from "./img/file_download.png"
import dashBoardIcon from "./img/home.png"
import { useContext, useState } from "react";
import Home from "../ContentArea/Home/Home";
import Guias from "../ContentArea/Guias/Guias";
import { PageContext } from "../Context/PageContext";
import Cadastro from "../ContentArea/Cadastro/Cadastro";
import NewAccountDescript from "../ContentArea/Cadastro/CadastroDescript/NewAccountDescript";
import ExpandIcon from "./img/expand_circle_down.png"
import MusicPlayerMedia from "../MusicPlayer/MusicPlayerMedia";
import Database from "../ContentArea/Database/Database";
import Rankings from "../ContentArea/Ranking/Rankings";
import Downloads from "../ContentArea/Download/Download";

var uiElement = '';
var NavElement = '';
var uBar = '';
var mBar = '';
var lBar = '';
var HambContainer = '';

function openMenu() {
        //uiElement.style.opacity = ".8";
        //uiElement.style.width = window.innerWidth + "px";
        NavElement.style.width = window.innerWidth + "px";

        uBar.style.backgroundColor = "white";
        mBar.style.backgroundColor = "white";
        lBar.style.backgroundColor = "white";

        uBar.style.transform = "rotate(-45deg)";
        uBar.style.position = "absolute";

        mBar.style.position = "absolute";
        mBar.style.bottom = "0px";

        lBar.style.position = "absolute";
        lBar.style.transform = "rotate(45deg)";

        HambContainer.style.scale = ".5";
        return;
    }

    function closeMenu() {
        
        //uiElement.style.opacity = "0";
        //uiElement.style.width = "0px";
        NavElement.style.width = "0px";

        //uBar.style.backgroundColor = "black";
        //mBar.style.backgroundColor = "black";
        //lBar.style.backgroundColor = "black";

        uBar.style.transform = "rotate(0deg)";
        uBar.style.position = "relative";

        mBar.style.position = "relative";
        mBar.style.bottom = " ";

        lBar.style.position = "relative";
        lBar.style.transform = "rotate(0deg)";

        HambContainer.style.scale = "1";

        return;
 
    }
    
function MenuHamburguerHandler(e) {
        uiElement = document.getElementById('uiElement');
        NavElement = document.getElementById('NavMaster');
        uBar = document.getElementById('uBar');
        mBar = document.getElementById('mBar');
        lBar = document.getElementById('lBar');
        HambContainer = document.getElementById('hContainer');


        if(parseFloat(NavElement.style.width) > 0) {
            closeMenu();
        } else { openMenu()}
    }

function NavBarNew() {

    const [musicPlayer, setMusicPlayer] = useState(<></>);

    const { setPage, setRegisterPageSection, dashBoardInitialPage } = useContext(PageContext);


    return(
        <NavContainer >

                <MobileMenuLine>
                    <MenuHamburguer id="hContainer">
                        <InvisibleButton onClick={(e)=> {
                        MenuHamburguerHandler(e);
                        if(parseFloat(e.target.parentNode.parentNode.style.width) !== 0){
                            setMusicPlayer(<MusicPlayerMedia/>);
                        } else {
                            setMusicPlayer(<></>)
                        }
                        }}/>
                        <UperBar id="uBar"/>
                        <MiddleBar id="mBar"/>
                        <LowerBar id="lBar"/>
                    </MenuHamburguer>
                    <TitleMBar >LionsRagnarok</TitleMBar>
                </MobileMenuLine>

        <NavMasterContainer id="NavMaster">
            <Ul id="uiElement">
                <Li onClick={() => {setPage(<Home />); closeMenu(); setMusicPlayer(<></>)}}><IconImg img={forumIcon}/>HOME</Li>
                <Li onClick={() =>{
                    setPage(<Cadastro/>);
                    closeMenu();
                    setMusicPlayer(<></>)
                    setRegisterPageSection(<NewAccountDescript/>)}}><IconImg img={editIcon}/>CADASTRO</Li>
                <Li onClick={() => {setPage(<Guias/>); closeMenu(); setMusicPlayer(<></>)}}><IconImg img={nearMeIcon} />GUIAS</Li>
                <Li onClick={() => {setPage(<Rankings/>); closeMenu(); setMusicPlayer(<></>)}}><IconImg img={personPinIcon} />RANKINGS</Li>
                <Li onClick={() => {setPage(<Database/>); closeMenu(); setMusicPlayer(<></>)}}><IconImg img={importContacsIcon} />DATABASE</Li>
                <Li onClick={() => {setPage(<Downloads/>); closeMenu(); setMusicPlayer(<></>)}}><IconImg img={fileDownloadIcon} />DOWNLOAD</Li>
                <Li onClick={() => {setPage(<>{dashBoardInitialPage}</>); closeMenu(); setMusicPlayer(<></>)}}><IconImg img={dashBoardIcon} />CONTA</Li>
            </Ul>
        </NavMasterContainer>
        </NavContainer>
    );
};

export default NavBarNew;

const NavContainer = styled.nav`
    margin: 0;
    padding: 0;
    //border: solid 2px black;
    position: fixed; 
    display: flex;
    justify-content: start;
    flex-direction: column;
    align-items: center;
    opacity: 1;
    transition: .3s ease-in-out;
    //left: 0px;
    z-index: 10;


    &:hover {
    //margin: -30px 0 20px 0;
    }
`;

const NavMasterContainer = styled.nav`
    margin: 0;
    padding: 0;
    //border: solid 2px black;
    //self: start;
    width: 0;
    height: 100%;
    display: flex;
    justify-content: center;
    //align-items: center;

    overflow: hidden;
    opacity: 1;
    transition: .3s ease-in-out;
    position: fixed;
    left: 0px;
    background-color: rgba(156, 5, 5, 1);

    &:hover {
    //margin: -30px 0 20px 0;
    }
`;



const MobileMenuLine = styled.div`
    background-color: rgba(156, 5, 5, 1);
    width: 100vw;
    height: 50px;
    text-align: center;
    //border: solid;
    display: flex;
    justify-content: center;
    border-radius: 10px;
    z-index: 11;

    &:hover {
    background-color: rgba(156, 5, 5, 1);
    }
`

const TitleMBar = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 24pt;
    font-weight: bold;
    //border: solid;
    width: 300px;
`

const TitleLanc = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14pt;
    font-weight: bold;
    //border: solid;
    //width: 300px;
`
const MenuHamburguer = styled.div`
    border: solid 0px;
    width: 30px;
    height: 30px;
    padding: 0px;
    background-color: rgba(156, 5, 5, 1);
    transitions: .3s ease-in-out;
    scale: 1;
    z-index: 10;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    transition: .3s ease-in-out;
    border-radius: 50%;
    margin: 0 0px 0 -40px;
`

const InvisibleButton = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 2;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

`

const UperBar = styled.div`
    width: 90%;
    height: 2px;
    background-color: white;
    transform: rotate(0deg);
    transitions: .3s ease-in-out;
    transform: rotate(0deg);
    position: relative;
 
`
const MiddleBar = styled.div`
    width: 70%;
    height: 2px;
    background-color: white;
    transitions: .3s ease-in-out;
    position: relative;

`
const LowerBar = styled.div`
    width: 90%;
    height: 2px;
    background-color: white;
    transitions: .3s ease-in-out;
    transform: rotate(0deg);
    position: relative;
`


const Ul = styled.ul`
    margin: 60px 0 10px 0;
    padding: 0px 0px;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    list-style-type: none;
    width: 300px;
    height: 400px;
    overflow: hidden;
    transition: .3s ease-in-out;
    background-color: rgba(156, 5, 5, .9);
    opacity: 1;
    //border: solid;

`;

const Li = styled.li`
    display: flex;
    align-items: center;
    font-size: 12pt;
    color: white;
    padding: 0px 0px;
    letter-spacing: 0.02rem;
    justify-content: start;
    margin: 5px 0px;
    position: relative;
    //border: solid 1px black;
    padding: 10px 20px;
    width: 200px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

     &:hover {
        filter: contrast(500%);
        transition: .3s;
        scale: 1.2;
        margin-left: 40px;
        background-color: white;
        color: red;
     }
    &:not(:hover) {
        transition: .3s;
     }

`;

const LiBlocked = styled.li`
    display: flex;
    align-items: center;
    font-size: 12pt;
    color: white;
    padding: 0px 0px;
    letter-spacing: 0.02rem;
    justify-content: start;
    margin: 5px 0px;
    opacity: .5;
    position: relative;
    //border: solid 1px black;
    padding: 10px 20px;
    width: 200px;
    pointer-events: none;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

     &:hover {
        filter: contrast(500%);
        transition: .3s;
        scale: 1.2;
        margin-left: 40px;
        background-color: white;
        color: red;
     }
    &:not(:hover) {
        transition: .3s;
     }

`;

const IconImg = styled.div `
    background-image: url('${props => props.img}');
    background-size: cover;
    width: 20px;
    height: 20px;
    margin-right: 40px
    
`




